import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Card, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/controller";

//COMPONENTS
import AddPodcast from "./addPodcast";
import FileNameSlot from "./fileNameSlot";

function Controller() {
  const dispatch = useDispatch();
  const [podcasts, setPodcasts] = useState([]);

  const [addPodcast, setAddPodcast] = useState({
    open: false,
  });

  const [modalYN, setModalYN] = useState({
    open: false,
    heading: "",
    message: "",
    acceptFunction: "",
    acceptName: "",
    showAccept: false,
    cancelName: "",
    showCancel: false,
  });

  function handleModalYNClose() {
    setModalYN((prevState) => {
      return { ...prevState, open: false };
    });
  }

  function handleCloseAddPodcast() {
    setAddPodcast((prevState) => {
      return { ...prevState, open: false };
    });
  }

  function handleOpenAddPodcast() {
    setAddPodcast((prevState) => {
      return { ...prevState, open: true };
    });
  }

  useEffect(() => {
    dispatch(GS_navSettingsActions.UpdateTitle("Podcasts"));
    dispatch(GS_navSettingsActions.UpdateSelected("Features"));
    dispatch(GS_navSettingsActions.UpdateSubSelected("Podcasts"));

    loadPodcasts();
  }, []);

  function loadPodcasts() {
    Axios.post("/pods/podcastAdmin/getAllPodcasts")
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setPodcasts(data.podcasts);
        }
      })
      .catch((err) => console.log(err));
  }

  function handleDeletePodcast(uuid) {
    setModalYN({
      heading: "Podcast",
      message: "Are you sure you want to delete this podcast?",
      showAccept: true,
      acceptName: "Yes",
      acceptFunction: acceptDeletePodcast.bind(this, uuid),
      showCancel: true,
      cancelName: "No",
      open: true,
    });
  }

  function acceptDeletePodcast(id) {
    setModalYN((prevState) => {
      return { ...prevState, open: false };
    });

    const data = { uuid: id };
    Axios.post("/pods/podcastAdmin/deletePodcast", data)
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          loadPodcasts();
        }
      })
      .catch((err) => console.log(err));

    console.log(id);
  }

  return (
    <div style={ControllerStyles.body}>
      <Row>
        <Col style={ControllerStyles.podcastBtn}>
          <Button onClick={handleOpenAddPodcast}>Add Podcast</Button>
        </Col>
      </Row>
      <div style={ControllerStyles.podcastsHeaderSection}>
        <Card style={ControllerStyles.headerCardStyles}>
          <Card.Body>
            <Row>
              <Col sm={4}>Title</Col>
              <Col sm={5}>Filename</Col>
              <Col sm={2}>Duration</Col>
              <Col sm={1}></Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
      <div style={ControllerStyles.podcastsSection}>
        <br />
        {podcasts.map((podcast, index) => {
          return (
            <div key={index}>
              <Card style={ControllerStyles.cardStyles}>
                <Card.Body>
                  <Row>
                    <Col sm={4}>{podcast.title}</Col>
                    <Col sm={5}>
                      <FileNameSlot name={podcast.filename} />
                    </Col>
                    <Col sm={2}>{podcast.duration}</Col>
                    <Col sm={1}>
                      <Button
                        variant="danger"
                        onClick={handleDeletePodcast.bind(this, podcast.uuid)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <br />
            </div>
          );
        })}
      </div>
      <Modal show={modalYN.open} onHide={handleModalYNClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalYN.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalYN.message}</Modal.Body>
        <Modal.Footer>
          {modalYN.showAccept ? (
            <div>
              <Button variant="primary" onClick={modalYN.acceptFunction}>
                {modalYN.acceptName}
              </Button>
            </div>
          ) : null}
          {modalYN.showCancel ? (
            <div>
              <Button variant="primary" onClick={handleModalYNClose}>
                {modalYN.cancelName}
              </Button>
            </div>
          ) : null}
        </Modal.Footer>
      </Modal>
      <AddPodcast
        open={addPodcast.open}
        close={handleCloseAddPodcast}
        reload={loadPodcasts}
      />
    </div>
  );
}

export default Controller;
